import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { AsyncButton, SectionIntro, Text } from '@ui';

const Archived = () => {
  const { t } = useTranslation(['onboarding', 'common']);
  const { acknowledgeDeactivation } = useEntityIntakeFormContext();

  return (
    <>
      <SectionIntro
        hideDivider
        titleColor={colorsTheme.colorWhite}
        title={t('intake_form.archived.title')}
      />
      <TextWithTopMargin>
        {t('intake_form.archived.description')}
      </TextWithTopMargin>
      <StyledButton size="large" onClick={acknowledgeDeactivation}>
        {t('intake_form.acknowledge_and_exit')}
      </StyledButton>
    </>
  );
};

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledButton = styled(AsyncButton)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

export default Archived;
